import { Group, UnstyledButton } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { MercuryCol, MercuryGrid } from '@/components/grid/Grid';
import MercuryTitle from '@/components/content/title/Title';
import ContactSupport from '@/client/features/mailboxes/ContactSupport';
import CreditsAvailable from '../components/CreditsAvailable';
import TransactionsInfo from '../components/transactions/TransactionsInfo';
import { historyIndexFromState, transactionsBackTarget } from '../utils/transactionsBack';

import ChevronLeft from '@/assets/icons/content/chevron-left.svg';

import classes from './Transactions.module.css';

const Transactions = () => {
  const navigate = useNavigate();

  const goBack = () => {
    const target = transactionsBackTarget(historyIndexFromState(window.history.state));
    if (typeof target === 'number') {
      navigate(target);
      return;
    }

    navigate(target);
  };

  return (
    <MercuryGrid>
      <MercuryCol transparent>
        <div className={classes.header}>
          <div className={classes.titleGroup}>
            <UnstyledButton className={classes.backButton} aria-label="Back" onClick={goBack}>
              <ChevronLeft />
            </UnstyledButton>
            <MercuryTitle order={1} fz={20} fw={400} lh="28px" c="var(--ds-font-color)">
              My Transactions
            </MercuryTitle>
          </div>

          <Group gap={8} wrap="nowrap">
            <CreditsAvailable to={false} />
            <ContactSupport />
          </Group>
        </div>
      </MercuryCol>
      <MercuryCol transparent>
        <TransactionsInfo />
      </MercuryCol>
    </MercuryGrid>
  );
};

export default Transactions;
